export enum PerformanceReviewQueryKey {
  MonthlyKpis = 'performance-review-monthly-kpis',
  RegionalManagerKpisComments = 'regional-manager-kpis-comments'
}
